



















































































































































































































































































































































































































interface VoucherValue {
    message: string;
    code: number;
    data: any;
}
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import VoucherImportVue from "../components/VoucherList/VoucherImport.vue";
import VoucherCopyVue from "../components/VoucherList/VoucherCopy.vue";
import VoucherFailVue from "../components/VoucherList/VoucherFail.vue";
import envidenceVue from "../components/VoucherList/envidence.vue";
import version from "@/version";

@Component({
    components: {
        "month-selector": MonthSelectorVue,
        "voucher-import": VoucherImportVue,
        "voucher-fail": VoucherFailVue,
        envidence: envidenceVue,
        "voucher-copy": VoucherCopyVue,
    },
    ...mapGetters(["accountBook"]),
})
export default class VoucherList extends Vue {
    @Prop({ type: Boolean })
    isDialog!: boolean;

    filterVisible: boolean = false;
    // 搜索字段
    searchQuery: string = "";
    // 显示整理断号
    showBreak: boolean = false;

    vouchers: Voucher.Voucher[] = [];
    	    // 修改页数SIze
	changeSize(size: number) {
    	this.pageSize = size;
		this.fetchData();
    }

    // 分页
    currentPage: number = 1;
    pageSize: number = 30;
    totalElements: number = 0;
    cannotEdit: boolean = false;
    noVouchers: boolean = false;

    shList = [
        { id: "0", text: "未审核凭证" },
        { id: "1", text: "已审核凭证" },
        { id: "2", text: "全部审核" },
    ]
    pzList = [
        { id: 11, text: "全部" },
        { id: 2, text: "销项发票" },
        { id: 3, text: "进项发票" },
        { id: 4, text: "银行" },
        { id: 5, text: "其他发票" },
        { id: 1, text: "工资" },
        { id: 0, text: "手工凭证" },

    ]
    // 合并凭证
    isShowMerge: boolean = false;
    checkVouchers: string = "";

    exportList() {
        const url = `${Vue.axios.defaults.baseURL}export/vouchereasy?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&version=${version}&token=${this.$store.state.account.token}&summary=${this.summary}&foreSubText=${this.foreSubText}&minBalance=${this.minBalance === "" ? "" : this.minBalance}&maxBalance=${this.maxBalance === "" ? "" : this.maxBalance}&minVoucherNo=${this.minVoucherNo === "" ? "" : this.minVoucherNo}&maxVoucherNo=${this.maxVoucherNo === "" ? "" : this.maxVoucherNo}&state=${this.state === "2" ? "" : this.state}&category=${this.category === 11 ? "" : this.category}`;
        this.$utils.sendToElectron("download", url);
    }

    merge() {
        let checkedVouchers: any = [];
        this.vouchers.forEach((v: Voucher.Voucher) => {
            if (v.checked) checkedVouchers.push(v.id);
        });
        if (checkedVouchers.length <= 1) {
            this.$alert("亲，请至少选择两张凭证！", "温馨提示");
        } else {
            this.isShowMerge = true
            this.checkVouchers = checkedVouchers.join(",")
        }
    }
    mergeApi(vouchers: any) {
        Vue.axios
            .post(
                `vouchers/merge?voucherIds=${vouchers}&accountBookId=${this.$store.state.accountBook.id}&accessoryType=${""}&isSimpleMerge=${2}`, { a: 1 })
            .then(() => {
                this.isShowMerge = false
                this.fetchData()
            })
    }
    changeMore(command: string) {
        if (command === "批量复制凭证") {
            this.copyVoucher()
            return
        }
        if (command === "批量删除凭证") {
            this.delVoucher()
            return
        }
        if (command === "整理断号") {
            this.handleBreak()
        }
        else if (command === "合并凭证") {
            this.merge()
        }
        else if (command === "列表导出") {
            this.exportList();
        }
        else {
            this.$msgbox({
                message: "亲，重排后顺序不可恢复，确定需要重排吗",
                title: "温馨提示",
                confirmButtonText: "确定",
                showCancelButton: true,
                cancelButtonText: "取消",
            })
                .then((action: any) => {
                    if (action == "confirm") {
                        this.breakPeriod()
                    }
                })
                .catch(() => { });
        }
    }

    // 日期
    period: string[] = [];

    mounted() {
        this.$utils.getRemarks(this.$store.state.accountBook.id)
        if (!this.$utils.canControl()) {
            this.cannotEdit = true;
        } else {
            this.cannotEdit = false;
        }
    }
    state: string | null = "2";
    handleCommand(command: string) {
        if (command === "2") this.state = null;
        else this.state = command;
        this.fetchData();
    }

    get hasCheckedVoucher() {
        for (let i = 0; i < this.vouchers.length; i++) {
            if (this.vouchers[i].checked) return true;
        }
        return false;
    }
    // 切换账套重新获取月份
    async fetchPeriod() {
        await (<MonthSelectorVue>this.$refs.newDate).getPeriods();
        this.fetchData();
    }
    summary: string = "";
    foreSubText: string = "";
    minBalance: string = "";
    maxBalance: string = "";
    minVoucherNo: string = "";
    maxVoucherNo: string = "";
    category: string | number = 11;
    resetFilter() {
        this.summary = "";
        this.foreSubText = "";
        this.minBalance = "";
        this.maxBalance = "";
        this.minVoucherNo = "";
        this.maxVoucherNo = "";
        this.category = 11;
        this.state = "2";
        this.$nextTick(() => {
            this.fetchData();
            this.filterVisible = false;
        })
    }
    confirmFilter() {
        this.fetchData();
        this.filterVisible = false;
    }
    fetchData() {
        Vue.axios
            .post(
                `vouchers/findlist?page=${this.currentPage - 1}&size=${this.pageSize
                }`,
                {
                    accountBookId: this.$store.state.accountBook.id,
                    startPeriod: this.period[0],
                    endPeriod: this.period[1],
                    // query: this.searchQuery,
                    pageType: true,
                    state: this.state === "2" ? null : this.state,
                    summary: this.summary,
                    foreSubText: this.foreSubText,
                    minBalance: this.minBalance === "" ? null : this.minBalance,
                    maxBalance: this.maxBalance === "" ? null : this.maxBalance,
                    minVoucherNo: this.minVoucherNo === "" ? null : this.minVoucherNo,
                    maxVoucherNo: this.maxVoucherNo === "" ? null : this.maxVoucherNo,
                    category: this.category === 11 ? "" : this.category
                }
            )
            .then(res => {
                res.data.vouchers.content.forEach((v: Voucher.Voucher) => {
                    v.checked = false;
                    v.showMark = false;
                });
                this.vouchers = res.data.vouchers.content;
                this.totalElements = res.data.vouchers.totalElements;
                this.showBreak = res.data.isBreak === 1;
                if (this.vouchers.length === 0) this.noVouchers = true;
                else this.noVouchers = false;
            });
    }
    // 搜索关键字
    hlInner(con: string, type?: string) {
        let query = "";
        if (type === "summary") query = this.summary;
        else if (type === "subject") query = this.foreSubText;
        if (query != "") {
            let reg = new RegExp(`${query}`, "gim");
            return con.replace(
                reg,
                `<span class="hl">${query}</span>`
            );
        } else {
            return con;
        }
    }

    // 分页
    changePage(val: number) {
        this.checkedVouchers = [];
        this.currentPage = val;
        this.fetchData();
    }

    // 日期改变
    changeDate(date: string[]) {
        this.period = date;
        let cur = this.period[0];
        let close = this.$store.state.accountBook.closePeriod;
        this.currentPage = 1;
        if (cur > close && this.$utils.canControl()) {
            this.cannotEdit = false;
        } else {
            this.cannotEdit = true;
        }
        this.fetchData();
        // this.$utils.getRemarks()

    }
    // 导入
    isImport: boolean = false;
    showFail: boolean = false;
    message: string = "";
    voucherFail: Voucher.VoucherImport[] = [];
    failSubject: Voucher.VoucherImport[] = [];
    showImport() {
        this.isImport = true;
    }
    successImport(value: VoucherValue) {
        if (value.code === 1) {
            this.voucherFail = value.data.needToSetAssSubjects;
            this.failSubject = value.data.needToChooseChildSubjects;
            this.message = value.message;
            this.showFail = true;
            this.isImport = false;
        }
        if (value.code === 200) {
            this.$msgbox({
                message: value.data,
                title: value.message,
                confirmButtonText: "确定",
                showCancelButton: true,
            });
            // this.fetchData()
            this.fetchPeriod();
            this.isImport = false;
        }
    }
    closeImport() {
        this.isImport = false;
    }
    closeFail() {
        this.showFail = false;
    }
    // 整理段号
    handleBreak() {
        Vue.axios
            .post(`vouchers/rangebreak`, {
                accountBookId: this.$store.state.accountBook.id,
                startPeriod: this.period[0],
                endPeriod: this.period[1],
            })
            .then((res) => {
                this.fetchData();
            });
    }
    // 记账日期重排
    breakPeriod() {
        Vue.axios
            .post(`vouchers/rangebreak`, {
                accountBookId: this.$store.state.accountBook.id,
                startPeriod: this.period[0],
                endPeriod: this.period[1],
                isSortByDate: 1
            })
            .then((res) => {
                this.fetchData();
            });
    }
    // 全选
    checkAll: boolean = false;
    changeAll(val: boolean) {
        for (let i = 0; i < this.vouchers.length; i++) {
            if (val) {
                this.$set(this.vouchers[i], "checked", val);
            } else {
                this.$set(this.vouchers[i], "checked", val);
            }
        }
    }
    // 监听全选
    @Watch("vouchers", { deep: true })
    vouchersChange(val: Voucher.Voucher[]) {
        let all = true;
        for (let i = 0; i < val.length; i++) {
            if (!val[i].checked) {
                all = false;
                break;
            }
        }
        if (val.length === 0) all = false;
        this.checkAll = all;
    }
    //点击凭证
    checkTheVoucher(voucher: Voucher.Voucher, isView: boolean) {
        if (isView) {
            this.editVoucher(voucher, true);
        } else {
            this.$set(voucher, "checked", !voucher.checked);
        }
    }
    // 删除凭证
    deleteVoucher(voucher: Voucher.Voucher) {
        if (!this.cannotEdit && (!this.notNull || voucher.state != 1)) {
            this.$msgbox({
                message: "删除后将不可还原，确定要删除这条凭证吗？",
                title: "温馨提示",
                confirmButtonText: "确定",
                showCancelButton: true,
            }).then((action: any) => {
                if (action === "confirm") {
                    Vue.axios.post(`vouchers/delete`, voucher).then((res) => {
                        this.$notify({
                            type: "success",
                            title: "成功",
                            message: "删除成功！",
                        });
                        this.fetchData();
                    });
                }
            });
        }
    }
    //添加批注
    tmpData: string = "";
    addNote(voucher: Voucher.Voucher, i: number) {
        if (voucher.showMark) {
            voucher.showMark = false;
            voucher.remark = this.tmpData;
        } else {
            this.vouchers.forEach((v: Voucher.Voucher) => {
                if (v.showMark) v.showMark = false;
            });
            voucher.showMark = true;
            this.$nextTick(() => {
                (<any>this.$refs.mark)[0].focus();
            });
        }
    }
    // 临时数据
    saveTmp(val: string) {
        this.tmpData = val;
    }
    // 添加备注
    remarkThis(voucher: Voucher.Voucher) {
        if (voucher.remark != this.tmpData) {
            Vue.axios
                .post(`vouchers/remark`, {
                    id: voucher.id,
                    remark: voucher.remark,
                })
                .then((res) => {
                    this.$message({
                        message: "备注修改成功！",
                        type: "success",
                    });
                });
        }
        voucher.showMark = false;
    }
    //修改凭证
    notNull: boolean = this.$utils.notNull([
        this.$store.state.accountBook.reviewer,
    ]);
    voucherShow: boolean = false;
    async editVoucher(voucher: any, isView?: boolean) {
        const res = await Vue.axios.post(`voucher/` + voucher.id + `/find`, { id: 0 });
        this.voucherShow = true;
        this.$nextTick(() => {
            let newVoucher: any = this.$refs.newVoucher;
            newVoucher.isDialog = true;
            newVoucher.shouldGetInit = false;
            newVoucher.isEdit = !isView;
            newVoucher.isInsert = 0;
            newVoucher.isCheck = false;
            newVoucher.showSaveAndAdd = false;
            newVoucher.showAdd = false;
            newVoucher.category = voucher.category;
            // if (!isView || (!this.cannotEdit && (!this.notNull || voucher.state != 1))) newVoucher.notEdit = false;
            // else newVoucher.notEdit = true;
            if (isView) newVoucher.notEdit = true;
            else newVoucher.notEdit = false;
            newVoucher.getSubjectList(null, () => {
                newVoucher.packVoucher(res.data);
                newVoucher.canFindPre = voucher.previous === 1;
                newVoucher.canFindNext = voucher.next === 1;
            });
        });
    }
    //关闭凭证模态框
    closeVoucherDialog() {
        this.fetchData();
    }
    //插入凭证
    appendVoucher(no: any, period: any) {
        if (!this.cannotEdit) {
            this.voucherShow = true;
            this.$nextTick(function () {
                let newVoucher: any = this.$refs.newVoucher;

                newVoucher.isDialog = true;
                newVoucher.shouldGetInit = false;
                // newVoucher.dateTime = new Date(
                //     period.substring(0, 4) + "/" + period.substring(4)
                // );
                newVoucher.isEdit = true;
                newVoucher.isCheck = false;
                newVoucher.showSaveAndAdd = true;
                newVoucher.showAdd = false;
                newVoucher.notEdit = false;
                newVoucher.category = 0;
                newVoucher.getInit(true, period, no);
            });
        }
    }
    // 批量打印
    printVoucher(voucher: Voucher.Voucher) {
        let vouchers: Voucher.Voucher[] = [];
        if (!voucher.checked) voucher.checked = true;
        this.vouchers.forEach((v) => {
            if (v.checked) vouchers.push(v);
        });

        if (vouchers.length > 0) this.$emit("printVoucher", vouchers);
    }
    checkedVouchers: Voucher.Voucher[] = [];
    get reviewName(): string {
        for (let i = 0; i < this.vouchers.length; i++) {
            if (this.vouchers[i].checked) {
                if (this.vouchers[i].state === 1) {
                    return "取消审核";
                } else return "批量审核";
            }
        }
        return "批量审核";
    }
    // // 批量审核
    batchAudit() {
        let checkedId: number[] = [];
        let id = "";
        this.checkedVouchers.forEach((v) => {
            checkedId.push(v.id);
        });
        if (this.checkedVouchers.length > 0) {
            if (this.checkedVouchers.length === 1) {
                id = checkedId.join("");
            } else id = checkedId.join(",");
            if (!this.cannotEdit) {
                Vue.axios
                    .post(`vouchers/audit?id=${id}`, { pass: "" })
                    .then((res) => {
                        this.fetchData();
                    });
            } else {
                this.$message.warning("无法审核凭证");
            }
        } else {
            this.$message.warning("请勾选凭证");
        }
    }

    // 显示附件
    showOrg: boolean = false;
    currentAttach: Envidence | null = null;
    attachType: string = "";
    showAccessory(id: number) {
        Vue.axios
            .get(
                `vouchers/viewattachments?accountBookId=${this.$store.state.accountBook.id}&voucherId=${id}`
            )
            .then((res) => {
                this.currentAttach = res.data;

                if (
                    res.data.journalList != null ||
                    res.data.invoiceDtos != null ||
                    res.data.others != null ||
                    res.data.paySheets != null
                ) {
                    if (res.data.journalList != null)
                        this.attachType = "dayAccount";
                    else if (res.data.invoiceDtos != null)
                        this.attachType = "invoice";
                    else if (res.data.others != null)
                        this.attachType = "others";
                    else if (res.data.paySheets != null)
                        this.attachType = "salaryList";
                    this.showOrg = true;
                }
            });
    }

    // 搜索
    startSearch() {
        this.currentPage = 1;
        this.fetchData();
    }
    // 审核凭证
    auditClick(id: any) {
        if (!this.cannotEdit) {
            Vue.axios
                .post(`vouchers/audit?id=${id}`, { pass: "" })
                .then((res) => {
                    this.fetchData();
                });
        }
    }

    // 判断审核状态
    getReviewVisible() {
        let flag = null;
        let arr = [];
        let count = 0;
        for (let i = 0; i < this.vouchers.length; i++) {
            let v = this.vouchers[i];
            if (v.checked) {
                count++;
                if (flag === null) flag = i;
                if (v.state === this.vouchers[<number>flag].state) {
                    arr.push(v);
                }
            }
        }
        if (arr.length === count && count != 0) {
            this.checkedVouchers = arr;
            return true;
        }
        this.checkedVouchers = [];
        return false;
    }

    // 修改凭证号
    async editNo(voucher: Voucher.Voucher) {
        if (!this.cannotEdit && (!this.notNull || voucher.state != 1)) {
            let data = await this.$prompt("请输入凭证号", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputValue: voucher.voucherNo,
                inputType: "number",
            });
            // @ts-ignore
            let val = data.value;
            if (val != "") {
                let no = parseInt(val);
                if (no < 100 && no >= 10) {
                    val = "0" + no;
                } else if (no < 10) {
                    val = "00" + no;
                } else {
                    val = no;
                }
            }
            await Vue.axios.post("vouchers/update/no", {
                id: voucher.id,
                voucherNo: val,
            });
            this.fetchData();
        }
    }
    // 复制上月凭证
    isCopy: boolean = false;
    dateTime: Date = new Date();
    copyId: string = "";
    copyClose(val: boolean, time: string) {
        if (val) {
            let period = { period: time }
            let selector: any = this.$refs.newDate;
            selector.clickMonth(period);
            // this.fetchData();
        }
        this.isCopy = false;
    }

    copyVoucher() {
        this.copyId = "";
        let arr = [];
        for (let i = 0; i < this.vouchers.length; i++) {
            if (this.vouchers[i].checked) arr.push(this.vouchers[i].id);
        }
        if (arr.length > 0) {
            this.isRed = false
            this.copyId = arr.join(",");
            this.isCopy = true;
        } else this.$message.warning("请选择需要复制的凭证");
    }
    // 红冲
    reset() {
        this.isCopy = false;
        this.fetchData()
    }
    isRed: boolean = false
    redRush(id: number) {
        this.isRed = true
        let idStr = id.toString();
        this.copyId = idStr;
        this.isCopy = true;
        // this.$confirm("亲，是否对此凭证进行红冲", "温馨提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning",
        // }).then(() => {
        //     Vue.axios
        //         .post(`vouchers/repair?idStr=${idStr}`, { nothing: 1 })
        //         .then((res) => {
        //             this.fetchData();
        //         });
        // });
    }
    // 跳转凭证
    newVoucher() {
        let period = this.period[1];
        let parm: any = { period };
        const close = this.$store.state.accountBook.closePeriod;
        this.$router.push({
            path: "/voucher",
            query: close !== null && +close >= +period ? undefined : parm,
        });
    }
    // 新tab跳转凭证
    newTabVoucher() {
        // let period = this.period[1];
        // let parm: any = { period };
        // const close = this.$store.state.accountBook.closePeriod;
        // this.$route.query = close !== null && +close >= +period ? undefined : parm;
        this.$store.dispatch("contextMenu", {
            url: "/voucher",
            name: "新增凭证"
        });
    }
    // 批量删除凭证
    delId: string = "";
    delVoucher() {
        this.delId = "";
        let arr = [];
        for (let i = 0; i < this.vouchers.length; i++) {
            if (this.vouchers[i].checked) {
                if (
                    this.cannotEdit ||
                    (this.notNull && this.vouchers[i].state === 1)
                ) {
                    this.$message.warning("选择的凭证中有无法删除的凭证");
                    return;
                } else {
                    arr.push(this.vouchers[i].id);
                    this.delVoucherList(arr);
                }
            }
        }
    }
    delVoucherList(arr: any) {
        if (arr.length > 0) {
            this.delId = arr.join(",");
            this.$msgbox({
                message: "删除后将不可还原，确定要删除选中的凭证吗？",
                title: "温馨提示",
                confirmButtonText: "确定",
                showCancelButton: true,
            }).then((action: any) => {
                if (action === "confirm") {
                    Vue.axios
                        .post(`voucherlist/delete?id=${this.delId}`, {
                            nothing: 1,
                        })
                        .then(res => {
                            this.$notify({
                                type: "success",
                                title: "成功",
                                message: res.data.message
                            });
                            this.delId = "";
                            this.fetchData();
                        });
                }
            });
        } else this.$message.warning("请选择需要删除的凭证");
    }
}
